import React, { ReactNode } from "react";
import { Paragraph, SectionBreak } from "@bloomberg/media-ui-article";
import { CommonNode } from "@foundation/rich-text-react-renderer";

export interface RichtextParagraphProps {
    children: ReactNode;
    node: CommonNode;
    className?: string;
}

export default function BasicRichtextParagraph({
    children,
    node,
    className,
}: RichtextParagraphProps) {
    return (
        <>
            {node.data.class === "section-break" && <SectionBreak />}
            <Paragraph className={className}>{children}</Paragraph>
        </>
    );
}
